import React from 'react'
import ProductDetails from '../../components/containers/ProductDetails'



export default function ViewProduct() {
  return (
    <div>
      <ProductDetails/>
    </div>
  )
}
